module.exports = __webpack_public_path__ + "img/Remove_duotone.d7970501.png";